<template>
    <main class="max-width-container">
        <h1 class="form-title">Edit bucket list</h1>
        <SharedCopyNotice
            :shared-by="bucketList?.shared_by"
            item-label="bucket list"
        />
        <BucketListForm
            v-if="bucketList"
            :initial-values="bucketList"
            edit
            can-delete
            :errors="errors"
            :back-link="`/bucket-lists/${id}`"
            @submit-form="submitForm"
            @delete="deleteBucketList"
            @clear-error="clearError"
        />
    </main>
</template>

<script>
import BucketListForm from "js/components/forms/BucketListForm";
import SharedCopyNotice from "js/components/common/SharedCopyNotice";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import { useBucketListStore } from "js/stores/bucketListStore";
import { usePageErrorStore } from "js/stores/pageErrorStore";
import { pageErrorFrom } from "js/lib/server.js";

export default {
    name: "BucketListEdit",
    components: {
        BucketListForm,
        SharedCopyNotice,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            id: null,
            store: undefined,
            bucketList: null,
        };
    },
    async mounted() {
        this.store = useBucketListStore();
        this.id = parseInt(this.$route.params.id);
        try {
            this.bucketList = await this.store.fetch(
                `/api/bucket-lists/${this.id}`
            );
        } catch (err) {
            usePageErrorStore().set(pageErrorFrom(err));
        }
    },
    methods: {
        submitForm(data) {
            this.store
                .edit(`/api/bucket-lists/${this.id}?with-items`, data)
                .then((bl) => {
                    this.store.update(bl);
                    this.$router.push(`/bucket-lists/${this.id}`);
                })
                .catch(this.handleResponseErrors);
        },
        deleteBucketList() {
            this.store
                .delete(`/api/bucket-lists/${this.id}?with-items`)
                .then(() => {
                    this.store.remove(this.id);
                    this.$router.push("/bucket-lists");
                });
        },
    },
};
</script>
